export default __webpack_public_path__ + "static/media/mail.a339a053.svg";